import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { isSuccessResponse } from "utils/helper";
import { GET_REGIONS, SET_REGIONS } from "../types/regions";
import store from "../store";

const dispatch = store.dispatch;

// export const setRegions = (payload) => {
//   dispatch({
//     type: SET_REGIONS,
//     payload,
//   });
// };

export const getRegions = async () => {
  dispatch({ type: GET_REGIONS });
  try {
    const { data } = await makeRequest("get", routes.fetchRegions());

    if (isSuccessResponse(data)) {
      dispatch({
        type: SET_REGIONS,
        payload: data?.data,
      });
    }
  } catch (err) {
    console.log(err);
  }
};
